/* eslint-disable angular/log */
(function () {
  'use strict';

  class ConfigEventosCtrl {
    constructor($stateParams, Authenticator, SolucoesEnum, FeatureFlag, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys, tmhDynamicLocale) {
      this.authenticator = Authenticator;
      this.solucoesEnum = SolucoesEnum;
      this.hasPermissionOcorrenciaSolucao = false;
      this.hasPermissaoConfigPesoEventosSolucao = false;
      this.hasPermissaoConfigDescarteEventosSolucao = false;
      this.hasPermissaoConfigTurno = false;
      this.hasPermissionConfigAlerta = false;
      this.FeatureOuService = FeatureOuService;
      this.shouldDisplayWorkShift = false;
      this.tmhDynamicLocale = tmhDynamicLocale;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.tipoSubpagina = {
        TIPOS: 'tipos',
        TURNOS: 'turnos',
        OCORRENCIAS: 'ocorrencias',
        PESOS: 'pesos',
        DESCARTE: 'descarte',
        DEVICE_HEALTH_CONFIGURATION: 'device-health-configuration',
        DRIVER_PRIVACY: 'driver-privacy'
      };
      this.idiomaMap = {
        'EN_US': 'en-us',
        'PT_BR': 'pt-br',
        'ES_ES': 'es-es'
      };
      this.isLoading = true;
      this.featureFlag = FeatureFlag;
      this.flagEnableDeviceHealthConfiguration = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ENABLE_DEVICE_HEALTY_NOTIFICATION_SETTINGS);
      this.flagEnableDriverPrivacy = this.featurehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.ENABLE_DRIVER_PRIVACY);
      this.tipo = this.getTipo($stateParams.tipoSubpagina && $stateParams.tipoSubpagina.toLowerCase());
      this.hideTitle = $stateParams.hideTitle;
      this.setUserParams();
    }

    setUserParams() {
      this.authenticator.getUser().then((user) => {
        this.hasPermissionConfigAlerta = user.permissoesSolucao.includes('CONFIGURACAO_ALERTA_VISUALIZAR');
        this.hasPermissionOcorrencia = user.permissoesSolucao.includes('CONFIG_OCORRENCIA_VISUALIZAR');
        this.hasPermissionOcorrenciaSolucao = user.permissoesSolucao.indexOf('CONFIG_OCORRENCIA_VISUALIZAR') !== -1;
        this.hasPermissaoConfigPesoEventosSolucao = user.permissoesSolucao.indexOf('CONFIG_PESO_EVENTO_VISUALIZAR') !== -1;
        this.hasPermissaoConfigDescarteEventosSolucao = user.permissoesSolucao.indexOf('CONFIG_DESCARTE_VISUALIZAR') !== -1;
        this.hasPermissaoConfigTurno = user.permissoesSolucao.includes('ONE_PAGE_VISUALIZAR') || user.permissoesSolucao.includes('CONFIG_OCORRENCIA_VISUALIZAR');
        this.hasPermissaoConfigDeviceHealthConfiguration = user.permissoesSolucao.includes('CONFIG_SAUDE_DO_EQUIPAMENTO_VISUALIZAR') && this.flagEnableDeviceHealthConfiguration;
        this.hasPermissaoDriverPrivacy = this.flagEnableDriverPrivacy && user.isNa === true;
        const locale = this.idiomaMap[user.idioma] || 'pt-br';
        this.tmhDynamicLocale.set(locale);
        this.getEventsConfig(user.uo.id).finally(() => {
          this.isLoading = false;
        });
      });
    }

    getTipo(tipo) {
      switch (tipo) {
        case this.tipoSubpagina.TURNOS:
          return this.tipoSubpagina.TURNOS;
        case this.tipoSubpagina.PESOS:
          return this.tipoSubpagina.PESOS;
        case this.tipoSubpagina.OCORRENCIAS:
          return this.tipoSubpagina.OCORRENCIAS;
        case this.tipoSubpagina.DESCARTE:
          return this.tipoSubpagina.DESCARTE;
        case this.tipoSubpagina.DEVICE_HEALTH_CONFIGURATION:
          return this.tipoSubpagina.DEVICE_HEALTH_CONFIGURATION;
        case this.tipoSubpagina.DRIVER_PRIVACY:
          return this.tipoSubpagina.DRIVER_PRIVACY;
        default:
          return this.tipoSubpagina.TIPOS;
      }
    }
    getEventsConfig(userUoId) {
      return this.FeatureOuService.getEventsConfig(userUoId).then((eventNaConfig) => {
        this.shouldDisplayWorkShift = eventNaConfig;
      }).catch((error) => {
        console.error('Error loading featureOu config: ', error);
      });
    }
  }

  angular
    .module('configEventos')
    .controller('ConfigEventosCtrl', ConfigEventosCtrl);
}());
